import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// Form related
import { Field } from 'formik';
import {CheckboxWithLabel} from 'formik-material-ui';
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter";
import AuthorisedSignatories from "./AuthorisedSignatories";

import connectionFormStyle from "../../../assets/jss/material-dashboard-react/views/connectionFormStyle";

const useStyles = makeStyles(connectionFormStyle);

export default function AwareForm(props) {
    const {formField, values} = props;
    const classes = useStyles();
    const customerName = values.given_name + " " + values.surname;

    return (
        <div>
            <GridContainer>
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary">
                            <h4 className={classes.cardTitleWhite}>Are You Aware Form</h4>
                            <p className={classes.cardCategoryWhite}>By signing this form, I acknowledge that I have discussed the following points with my Vodafone Representative and agree that:</p>
                        </CardHeader>
                        <CardBody>
                            <GridContainer>
                                <GridItem xs={12} sm={6} md={4}>
                                    <h4 className={classes.sectionHeader}>{formField.application_agreement.label}</h4>
                                    <Field
                                        component={CheckboxWithLabel}
                                        name={formField.application_agreement.fields.approval.name}
                                        id={formField.application_agreement.fields.approval.name}
                                        type="checkbox"
                                        Label={{ label: formField.application_agreement.fields.approval.label, className: classes.awareFormCheckbox }}
                                    />
                                    <Field
                                        component={CheckboxWithLabel}
                                        name={formField.application_agreement.fields.application_by_me.name}
                                        id={formField.application_agreement.fields.application_by_me.name}
                                        type="checkbox"
                                        Label={{ label: formField.application_agreement.fields.application_by_me.label, className: classes.awareFormCheckbox }}
                                    />
                                    <Field
                                        component={CheckboxWithLabel}
                                        name={formField.application_agreement.fields.governed_by_terms.name}
                                        id={formField.application_agreement.fields.governed_by_terms.name}
                                        type="checkbox"
                                        Label={{ label: formField.application_agreement.fields.governed_by_terms.label, className: classes.awareFormCheckbox }}
                                    />
                                    <Field
                                        component={CheckboxWithLabel}
                                        name={formField.application_agreement.fields.application_for_purchase.name}
                                        id={formField.application_agreement.fields.application_for_purchase.name}
                                        type="checkbox"
                                        Label={{ label: formField.application_agreement.fields.application_for_purchase.label, className: classes.awareFormCheckbox }}
                                    />
                                    <Field
                                        component={CheckboxWithLabel}
                                        name={formField.application_agreement.fields.allow_credit_check.name}
                                        id={formField.application_agreement.fields.allow_credit_check.name}
                                        type="checkbox"
                                        Label={{ label: formField.application_agreement.fields.allow_credit_check.label, className: classes.awareFormCheckbox }}
                                    />
                                    <Field
                                        component={CheckboxWithLabel}
                                        name={formField.application_agreement.fields.min_commitment_period.name}
                                        id={formField.application_agreement.fields.min_commitment_period.name}
                                        type="checkbox"
                                        Label={{ label: formField.application_agreement.fields.min_commitment_period.label, className: classes.awareFormCheckbox }}
                                    />
                                    <Field
                                        component={CheckboxWithLabel}
                                        name={formField.application_agreement.fields.responsible_for_due.name}
                                        id={formField.application_agreement.fields.responsible_for_due.name}
                                        type="checkbox"
                                        Label={{ label: formField.application_agreement.fields.responsible_for_due.label, className: classes.awareFormCheckbox }}
                                    />
                                    <Field
                                        component={CheckboxWithLabel}
                                        name={formField.application_agreement.fields.company_authorized.name}
                                        id={formField.application_agreement.fields.company_authorized.name}
                                        type="checkbox"
                                        Label={{ label: formField.application_agreement.fields.company_authorized.label, className: classes.awareFormCheckbox }}
                                    />
                                    <h4 className={classes.sectionHeader}>{formField.contract_term.label}</h4>
                                    <Field
                                        component={CheckboxWithLabel}
                                        name={formField.contract_term.fields.term_charge_explained.name}
                                        id={formField.contract_term.fields.term_charge_explained.name}
                                        type="checkbox"
                                        Label={{ label: formField.contract_term.fields.term_charge_explained.label, className: classes.awareFormCheckbox }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <h4 className={classes.sectionHeader}>{formField.plan_critical_info.label}</h4>
                                    <Field
                                        component={CheckboxWithLabel}
                                        name={formField.plan_critical_info.fields.plan_explained.name}
                                        id={formField.plan_critical_info.fields.plan_explained.name}
                                        type="checkbox"
                                        Label={{ label: formField.plan_critical_info.fields.plan_explained.label, className: classes.awareFormCheckbox }}
                                    />

                                    <h4 className={classes.sectionHeader}>{formField.network_coverage.label}</h4>
                                    <Field
                                        component={CheckboxWithLabel}
                                        name={formField.network_coverage.fields.coverage_understood.name}
                                        id={formField.network_coverage.fields.coverage_understood.name}
                                        type="checkbox"
                                        Label={{ label: formField.network_coverage.fields.coverage_understood.label, className: classes.awareFormCheckbox }}
                                    />
                                    <Field
                                        component={CheckboxWithLabel}
                                        name={formField.network_coverage.fields.any_network.name}
                                        id={formField.network_coverage.fields.any_network.name}
                                        type="checkbox"
                                        Label={{ label: formField.network_coverage.fields.any_network.label, className: classes.awareFormCheckbox }}
                                    />
                                    <h4 className={classes.sectionHeader}>{formField.handset_insurance.label}</h4>
                                    <Field
                                        component={CheckboxWithLabel}
                                        name={formField.handset_insurance.fields.handset_insurance_offered.name}
                                        id={formField.handset_insurance.fields.handset_insurance_offered.name}
                                        type="checkbox"
                                        Label={{ label: formField.handset_insurance.fields.handset_insurance_offered.label, className: classes.awareFormCheckbox }}
                                    />
                                    <h4 className={classes.sectionHeader}>{formField.aware_devices.label}</h4>
                                    <Field
                                        component={CheckboxWithLabel}
                                        name={formField.aware_devices.fields.devices_provided.name}
                                        id={formField.aware_devices.fields.devices_provided.name}
                                        type="checkbox"
                                        Label={{ label: formField.aware_devices.fields.devices_provided.label, className: classes.awareFormCheckbox }}
                                    />
                                    <h4 style={{marginTop: "0px", marginBottom: "10px"}}>OR</h4>
                                    <Field
                                        component={CheckboxWithLabel}
                                        name={formField.aware_devices.fields.devices_deferred.name}
                                        id={formField.aware_devices.fields.devices_deferred.name}
                                        type="checkbox"
                                        Label={{ label: formField.aware_devices.fields.devices_deferred.label, className: classes.awareFormCheckbox }}
                                    />
                                    <h4 className={classes.sectionHeader}>{formField.aware_porting.label}</h4>
                                    <Field
                                        component={CheckboxWithLabel}
                                        name={formField.aware_porting.fields.porting_yes.name}
                                        id={formField.aware_porting.fields.porting_yes.name}
                                        type="checkbox"
                                        Label={{ label: formField.aware_porting.fields.porting_yes.label, className: classes.awareFormCheckbox }}
                                    />
                                    <Field
                                        component={CheckboxWithLabel}
                                        name={formField.aware_porting.fields.porting_date.name}
                                        id={formField.aware_porting.fields.porting_date.name}
                                        type="checkbox"
                                        Label={{ label: formField.aware_porting.fields.porting_date.label, className: classes.awareFormCheckbox }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <h4 className={classes.sectionHeader}>{formField.international_roaming.label}</h4>
                                    <Field
                                        component={CheckboxWithLabel}
                                        name={formField.international_roaming.fields.new_active_default.name}
                                        id={formField.international_roaming.fields.new_active_default.name}
                                        type="checkbox"
                                        Label={{ label: formField.international_roaming.fields.new_active_default.label, className: classes.awareFormCheckbox }}
                                    />
                                    <Field
                                        component={CheckboxWithLabel}
                                        name={formField.international_roaming.fields.old_unchanged.name}
                                        id={formField.international_roaming.fields.old_unchanged.name}
                                        type="checkbox"
                                        Label={{ label: formField.international_roaming.fields.old_unchanged.label, className: classes.awareFormCheckbox }}
                                    />
                                    <h4 className={classes.sectionHeader}>{formField.direct_debit_request.label}</h4>
                                    <Field
                                        component={CheckboxWithLabel}
                                        name={formField.direct_debit_request.fields.account_authorized.name}
                                        id={formField.direct_debit_request.fields.account_authorized.name}
                                        type="checkbox"
                                        Label={{ label: formField.direct_debit_request.fields.account_authorized.label, className: classes.awareFormCheckbox }}
                                    />
                                    <Field
                                        component={CheckboxWithLabel}
                                        name={formField.direct_debit_request.fields.can_cancel_debit.name}
                                        id={formField.direct_debit_request.fields.can_cancel_debit.name}
                                        type="checkbox"
                                        Label={{ label: formField.direct_debit_request.fields.can_cancel_debit.label, className: classes.awareFormCheckbox }}
                                    />
                                    <Field
                                        component={CheckboxWithLabel}
                                        name={formField.direct_debit_request.fields.corp_card_authorized.name}
                                        id={formField.direct_debit_request.fields.corp_card_authorized.name}
                                        type="checkbox"
                                        Label={{ label: formField.direct_debit_request.fields.corp_card_authorized.label, className: classes.awareFormCheckbox }}
                                    />
                                    <h4 className={classes.sectionHeader}>{formField.aware_privacy.label}</h4>
                                    <Field
                                        component={CheckboxWithLabel}
                                        name={formField.aware_privacy.fields.privacy_accepted.name}
                                        id={formField.aware_privacy.fields.privacy_accepted.name}
                                        type="checkbox"
                                        Label={{ label: formField.aware_privacy.fields.privacy_accepted.label, className: classes.awareFormCheckbox }}
                                    />
                                    <h4 className={classes.sectionHeader}>{formField.aware_billing.label}</h4>
                                    <Field
                                        component={CheckboxWithLabel}
                                        name={formField.aware_billing.fields.payment_terms_explained.name}
                                        id={formField.aware_billing.fields.payment_terms_explained.name}
                                        type="checkbox"
                                        Label={{ label: formField.aware_billing.fields.payment_terms_explained.label, className: classes.awareFormCheckbox }}
                                    />
                                </GridItem>
                                <GridItem xs={12}>
                                    <AuthorisedSignatories
                                        formField={formField}
                                        customerName={customerName}
                                        representativeHelperText="I confirm that I have sighted, copied and retained the required copies of Customer ID."
                                    />
                                </GridItem>
                            </GridContainer>
                        </CardBody>
                        <CardFooter>
                            &nbsp;
                        </CardFooter>
                    </Card>
                </GridItem>
            </GridContainer>
        </div>
    );
}